<template>
  <b-modal id="punch-card-confirm-delete-reward-modal" title="Are you sure you want to delete this reward?" centered>
    <p class="d-none text-center">Lorem ipsum dolor sit amet consectetur. Mauris et consequat diam aliquet est dolor lectus.</p>
    <template slot="modal-footer">
      <b-button variant="outline-secondary" class="mr-2" @click="close">Cancel</b-button>
      <b-button variant="primary" @click="deleteReward">Delete</b-button>
    </template>
  </b-modal>
</template>

<script>
import { mapFields } from "vuex-map-fields";
export default {
  computed: {
    ...mapFields("punchCard", ["campaignData"]),
  },
  data() {
    return {
      rewardToDelete: null
    }
  },
  mounted() {
    this.$root.$on("bv::show::modal", (modalId, rewardIndex) => {
      if (modalId === "punch-card-confirm-delete-reward-modal") {
        this.rewardToDelete = rewardIndex;
      }
    });
  },
  beforeDestroy() {
    this.$root.$off("bv::show::modal");
  },
  methods: {
    close() {
      this.$root.$emit("bv::hide::modal", "punch-card-confirm-delete-reward-modal");
      document.body.classList.remove("modal-open");
    },
    deleteReward() {
      this.campaignData.design.milestones.splice(this.rewardToDelete, 1);

      this.$nextTick(() => this.close());
    }
  }
}
</script>

<style lang="scss">
#punch-card-confirm-delete-reward-modal {
  &>.modal-dialog>.modal-content {
    &>.modal-header {
      &>.modal-title {
        width: 100%;
        font-family: MainFontBold, sans-serif;
        text-align: center;
        margin-top: 2.5rem;
      }
    }
  }
}
</style>
